import { z } from 'zod';
import { apiRequest } from '@/api/client';
import {
  gamificationEventsSeenBodySchema,
  gamificationEventsSeenResponseSchema,
  gamificationMeResponseEnvelopeSchema,
  gamificationPinBodySchema,
  gamificationPinResponseEnvelopeSchema,
  gamificationPublicResponseEnvelopeSchema,
  type ClearGamificationPinResponse,
  type GamificationMeState,
  type GamificationPublicState,
  type MarkGamificationEventsSeenResponse,
  type SetGamificationPinResponse,
} from '@/types/gamification';

const BASE = '/api/v1/gamification';

function parseEnvelope<T>(schema: z.ZodType<{ success: true; data: T }>, raw: unknown): T {
  return schema.parse(raw).data;
}

export async function getMyGamification(): Promise<GamificationMeState> {
  const response = await apiRequest<unknown>({ url: `${BASE}/me`, method: 'GET' });
  return parseEnvelope(gamificationMeResponseEnvelopeSchema, response);
}

export async function getPublicGamification(userId: string): Promise<GamificationPublicState> {
  const safeUserId = z.string().uuid().parse(userId);
  const response = await apiRequest<unknown>({
    url: `${BASE}/profiles/${encodeURIComponent(safeUserId)}`,
    method: 'GET',
  });
  return parseEnvelope(gamificationPublicResponseEnvelopeSchema, response);
}

export async function setGamificationPin(trophyId: string): Promise<SetGamificationPinResponse> {
  const payload = gamificationPinBodySchema.parse({ trophy_id: trophyId });
  const response = await apiRequest<unknown>({
    url: `${BASE}/pin`,
    method: 'PUT',
    data: payload,
  });
  return parseEnvelope(gamificationPinResponseEnvelopeSchema, response);
}

export async function clearGamificationPin(): Promise<ClearGamificationPinResponse> {
  const response = await apiRequest<unknown>({
    url: `${BASE}/pin`,
    method: 'DELETE',
  });
  return parseEnvelope(gamificationPinResponseEnvelopeSchema, response);
}

export async function markGamificationEventsSeen(
  throughEventId: string,
): Promise<MarkGamificationEventsSeenResponse> {
  const payload = gamificationEventsSeenBodySchema.parse({ through_event_id: throughEventId });
  const response = await apiRequest<unknown>({
    url: `${BASE}/events/seen`,
    method: 'POST',
    data: payload,
  });
  return gamificationEventsSeenResponseSchema.parse(response);
}
